import { render, staticRenderFns } from "./ContractService.yaml?vue&type=template&id=64f0dc81&component"
import script from "./ContractService.yaml?vue&type=script&lang=ts&component"
export * from "./ContractService.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports